export const GIT_TOOL_NAMES = {
  LIST_REPOS: "list_repos",
  CLONE_REPO: "clone_repo",
  REBIND_REPO: "rebind_repo",
  FETCH_PR_REF: "fetch_pr_ref",
  CLONE_TEMPLATE: "clone_template",
  CREATE_REPO: "create_repo",
  CREATE_BRANCH: "create_branch",
  GIT_COMMIT: "git_commit",
  GIT_PUSH: "git_push",
  OPEN_PULL_REQUEST: "open_pull_request",
  GRAPHITE_SUBMIT: "graphite_submit",
  GITHUB_RESTACK: "github_restack",
  GRAPHITE_RESTACK: "graphite_restack",
  SUBMIT_PR_REVIEW: "submit_pr_review",
  ADD_PR_COMMENT: "add_pr_comment",
  RESOLVE_REVIEW_THREAD: "resolve_review_thread",
  REQUEST_MERGE: "request_merge",
  REQUEST_DEPLOY: "request_deploy",
} as const;
